import { c as _c } from "react/compiler-runtime";
// @ts-nocheck
import { Percent, CurrencyUSD, Time, GraphQLDecimal } from '@/graphql/scalars';
import * as Types from '../../../../types/schema';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DownloadBalanceSheetExcelFileV2MutationVariables = Types.Exact<{
  householdID: Types.Scalars['ID']['input'];
}>;
export type DownloadBalanceSheetExcelFileV2Mutation = {
  __typename?: 'Mutation';
  downloadBalanceSheetExcelV2?: {
    __typename?: 'FileDownloadToken';
    token: string;
    expiresInSeconds: number;
  } | null;
};
export const Operations = {
  Mutation: {
    DownloadBalanceSheetExcelFileV2: 'DownloadBalanceSheetExcelFileV2' as const
  }
};

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy
    }
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options
  };
}
export const DownloadBalanceSheetExcelFileV2Document = gql`
    mutation DownloadBalanceSheetExcelFileV2($householdID: ID!) {
  downloadBalanceSheetExcelV2(householdID: $householdID) {
    token
    expiresInSeconds
  }
}
    `;
export type DownloadBalanceSheetExcelFileV2MutationFn = Apollo.MutationFunction<DownloadBalanceSheetExcelFileV2Mutation, DownloadBalanceSheetExcelFileV2MutationVariables>;

/**
 * __useDownloadBalanceSheetExcelFileV2Mutation__
 *
 * To run a mutation, you first call `useDownloadBalanceSheetExcelFileV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadBalanceSheetExcelFileV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadBalanceSheetExcelFileV2Mutation, { data, loading, error }] = useDownloadBalanceSheetExcelFileV2Mutation({
 *   variables: {
 *      householdID: // value for 'householdID'
 *   },
 * });
 */
export function useDownloadBalanceSheetExcelFileV2Mutation(baseOptions) {
  const $ = _c(2);
  let t0;
  if ($[0] !== baseOptions) {
    t0 = {
      ...defaultOptions,
      ...baseOptions
    };
    $[0] = baseOptions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const options = t0;
  return Apollo.useMutation(DownloadBalanceSheetExcelFileV2Document, options);
}
export type DownloadBalanceSheetExcelFileV2MutationHookResult = ReturnType<typeof useDownloadBalanceSheetExcelFileV2Mutation>;
export type DownloadBalanceSheetExcelFileV2MutationResult = Apollo.MutationResult<DownloadBalanceSheetExcelFileV2Mutation>;
export type DownloadBalanceSheetExcelFileV2MutationOptions = Apollo.BaseMutationOptions<DownloadBalanceSheetExcelFileV2Mutation, DownloadBalanceSheetExcelFileV2MutationVariables>;